export const STATUSES = {
  INCOMPLETE: 'incomplete',
  PLANIFIED: 'planified',
  COMPLETE: 'complete',
  VALID: 'valid',
  DONE: 'done',
  CANCELED: 'canceled',
}

export const MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  DUPLICATE: 'duplicate',
}
